<script setup lang="ts">
  /**
   * UserAvatar Component
   * Displays user initials in a circular avatar
   * Generic, reusable component for displaying user identity
   */

  import { getNameInitials } from '@/shared/lib/name';

  defineProps<{
    name: string;
    icon?: string;
  }>();
</script>

<template>
  <span
    v-if="!icon"
    class="w-8 h-8 rounded-full bg-[var(--theme-secondary)] flex flex-shrink-0 justify-center items-center text-white font-medium text-base"
  >
    {{ getNameInitials(name) }}
  </span>
  <img
    v-else
    :src="icon"
    :alt="name"
    class="w-8 h-8 rounded-full flex-shrink-0"
  >
</template>
